<template lang="pug">
div
  div
    kpi-cards-coupons(v-if="tipCons && appProgramTitle" :tipCons="tipCons" :params="params" :appProgram="appProgramTitle" @type-coupon="changeTypeCoupons")

  div
    ods-module(:header="$t('loyalty.asignedcoupons')")
      ods-row.actions(:gutter='32')
        ods-col(:span='8')
          filter-table(layout="text" @inputSearchFilter="inputSearchFilter")
        ods-col.actions(:span='24')
          div(v-if="appliedFiltersNumber && appliedFiltersNumber > 0")
            ods-badge.item(type="secondary" :value="appliedFiltersNumber")
            ods-button(
              @click="activarBuscador"
              type="text"
              size="medium"
              :loading="isloadingCuponesTable"
              :icon="buscadorAvanzado ? 'ods-icon-chevron-up' : 'ods-icon-chevron-down'"
              ) {{ $t('loyalty.advancedSearch') }}
          div(v-else)
            ods-button(
              @click="activarBuscador"
              type="text"
              size="medium"
              :loading="isloadingCuponesTable"
              :icon="buscadorAvanzado ? 'ods-icon-chevron-up' : 'ods-icon-chevron-down'"
              ) {{ $t('loyalty.advancedSearch') }}
          router-link.loyalty-plantillas-table__detalles(:to="{name: namePath }")
            ods-button(:disabled="false" size="medium") {{ this.$t('loyalty.assignCoupon') }}
      div(v-if="buscadorAvanzado")
        advanced-search(v-if="!isloadingCuponesTable"
          :parametros="params"
          @apply-advanced-search="applyAdvancedSearch"
          @clean-advanced-search="cleanAdvancedSearch")
      coupons-table(:params="params" :mediaAltura="buscadorAvanzado" :filterText="filterText")
</template>

<script>
import KpiCardsCoupons from '@/components/loyalty/Coupons/KpiCardsCoupons'
import FilterTable from '@/components/shared/FilterTable'
import CouponsTable from '@/components/loyalty/Coupons/CouponsTable'
import { mapActions, mapGetters } from 'vuex'
import AdvancedSearch from './AdvancedSearch.vue'

export default {
  name: 'CuponesTab',
  data () {
    return {
      appliedFiltersNumber: 0,
      filterText: null,
      params: { tipCons: 'T', nombreid: '', apellid1: '', apellid2: '', canaluso: '', plantillasseleccionadas: [], idclient: '', tipidcli: '', appProgramTitle: '' },
      buscadorAvanzado: false,
      namePath: 'CouponsAsing'
    }
  },
  components: {
    'kpi-cards-coupons': KpiCardsCoupons,
    'filter-table': FilterTable,
    'advanced-search': AdvancedSearch,
    'coupons-table': CouponsTable
  },
  computed: {
    ...mapGetters({
      getLang: 'getLang',
      tipCons: 'getTypeCoupon',
      appProgramTitle: 'getSelectedProgram',
      isloadingCuponesTable: 'isloadingCuponesTable'
    })
  },
  methods: {
    ...mapActions(['getProgram', 'setReloadCoupons', 'setReloadCouponsCount']),
    changeTypeCoupons (data) {
      if ((data && data.tipCons !== this.tipCons) || (data && data.refresh)) {
        this.params.tipCons = data.tipCons
        this.$store.commit('SET_TYPE_COUPON', data.tipCons)
        // console.log('changeTypeCoupons', data)
        this.setReloadCoupons(true)
      }
    },
    applyAdvancedSearch (data) {
      console.log('applyAdvancedSearch', data)
      this.activarBuscador()
      this.appliedFiltersNumber = Object.values(data).filter(x => (x !== null && x !== '')).length
      if (data.plantillasseleccionadas && data.plantillasseleccionadas.length) {
        this.appliedFiltersNumber += data.plantillasseleccionadas.length
      }
      this.appliedFiltersNumber -= 1
      this.params = data
      this.setReloadCouponsCount(true)
    },
    cleanAdvancedSearch (params) {
      console.log('cleanAdvancedSearch', params)
      this.setReloadCouponsCount(false)
      this.params = { ...params, tipCons: 'T' }
      this.appliedFiltersNumber = Object.values(params).filter(x => (x !== null && x !== '')).length
      this.setReloadCouponsCount(true)
    },
    inputSearchFilter (text) {
      this.filterText = text
    },
    activarBuscador () {
      this.buscadorAvanzado = !this.buscadorAvanzado
    }
  },
  watch: {
    async appProgramTitle (newVal, oldVal) {
      if (newVal) {
        this.appliedFiltersNumber = 0
        this.filterText = null
        this.buscadorAvanzado = false
        this.params = { tipCons: 'T', nombreid: '', apellid1: '', apellid2: '', canaluso: '', plantillasseleccionadas: [], idclient: '', tipidcli: '', appProgramTitle: newVal }
        // console.log(`appProgramTitle ${newVal} ${oldVal}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  align-items: center;
  padding: 1px;
}
.actionsEnd {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  align-items: center;
  padding: 1px;
}
</style>
